import { useState, useEffect } from "react";
import DataTable from "../../components/DataTable";
import payoutsCols from "./payoutsCols";
import { listInvoices } from "../../distflowAPI/invoicesApi";
import { Link, NavLink } from "react-router-dom";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  TextField,
} from "@mui/material";
import dayjs from "dayjs";
import { DATE_FORMAT_FRONT } from "../../utils/constants";
import { getNoPages } from "../../utils";
import DatePickerCustom2 from "../../components/DatePicker2";
import {
  createTagBasedCommissions,
  listTagBasedCommissions,
} from "../../distflowAPI/salesmenApi";

const tag_col = {
  sortable: true,
  comparator: () => {},
  wrapText: true,
  minWidth: 200,
  maxWidth: 200,
  headerName: "tag",
  field: "tag",
};
const percentage_col = {
  sortable: true,
  comparator: () => {},
  wrapText: true,
  minWidth: 150,
  maxWidth: 150,
  headerName: "percentage",
  field: "percentage",
};
const skus_col = {
  sortable: true,
  comparator: () => {},
  wrapText: true,
  minWidth: 150,
  headerName: "skus",
  field: "skus",
  flex: 2,
  dataGetter: (params) => `${params?.data}`,
};
const invoiceTableColumns = [tag_col, percentage_col, skus_col];
export default function TagBasedCommissions({ salesManId }) {
  const [invoices, setInvoices] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [noPages, setNoPages] = useState(1);
  const [filterBy, setFilterBy] = useState({
    column: "sales_man",
    value: salesManId,
  });
  function refreshTable() {
    listTagBasedCommissions(salesManId, 1, 50).then((res) => {
      setInvoices(res.data.results);
      setNoPages(getNoPages(res.data.cout, pageSize));
    });
  }
  useEffect(() => {
    const filtersList = Object.keys(filterBy).map((fk) => {
      return {
        column: fk,
        value: filterBy[fk],
      };
    });
    refreshTable();
  }, [salesManId, page, pageSize, filterBy]);
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  return (
    <Stack spacing={2}>
      <Stack justifyContent={"end"} alignItems={"end"}>
        <Button
          variant="contained"
          color="success"
          sx={{ maxWidth: "20%" }}
          onClick={() => setIsCreateOpen(true)}
        >
          Create Tag Based Commission
        </Button>
      </Stack>
      <CreateTagBasedCommission
        salesManId={salesManId}
        open={isCreateOpen}
        setOpen={setIsCreateOpen}
        refreshTable={refreshTable}
      />
      <DataTable
        columnDefs={invoiceTableColumns}
        rowData={invoices}
        page={page}
        pageSize={pageSize}
        setPage={(p) => setPage(p)}
        setPageSize={(ps) => setPageSize(ps)}
        noPages={noPages}
      />
    </Stack>
  );
}

function CreateTagBasedCommission({ salesManId, open, setOpen, refreshTable }) {
  const [tag, setTag] = useState("");
  const [errors, setErrors] = useState({});
  const [percentage, setPercentage] = useState("8.00");
  function handleSubmit() {
    if (tag) {
      createTagBasedCommissions(salesManId, tag, percentage).then(
        (res) => {
          console.log("payout created... ", res);
          refreshTable();
          setOpen(false);
        },
        (err) => {
          console.log("error is: ", err);
          setErrors(
            err?.response?.data || { error: "something went wrong..." }
          );
        }
      );
    }
  }
  return (
    <Dialog
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Create Tag Based Commission </DialogTitle>
      <DialogContent>
        <Stack spacing={1}>
          {Object.keys(errors).map((ek) => (
            <Alert severity={"error"}>
              {ek}:{errors[ek]}
            </Alert>
          ))}

          <TextField
            sx={{ marginTop: 2 }}
            value={tag}
            onChange={(e) => setTag(e.target.value)}
            label={"Tag"}
          />
          <TextField
            required={true}
            name="percentage"
            label="Comission %"
            value={percentage}
            onChange={(e) => {
              setPercentage(e.target.value);
            }}
            fullWidth
            sx={{ margin: "8px" }}
            type="number"
          />
        </Stack>
      </DialogContent>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          m: "20px",
          gap: "10px",
        }}
      >
        <Button
          variant="contained"
          color="success"
          onClick={() => handleSubmit()}
        >
          Create
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={() => {
            setOpen(false);
          }}
        >
          Cancel
        </Button>
      </Box>
    </Dialog>
  );
}
